import { render, staticRenderFns } from "./AuthCongratulationsNonMasterUserMobileOverlay.vue?vue&type=template&id=13d543db"
import script from "./AuthCongratulationsNonMasterUserMobileOverlay.vue?vue&type=script&lang=js"
export * from "./AuthCongratulationsNonMasterUserMobileOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports